/**
 * Print / download the paper forms for a job (docs/04). The PDF opens in a new tab, where the
 * browser's Print button prints it; every print and download is audit-logged by the server.
 */
import type { Me } from '@wo/shared';
import { Card } from './ui';

const FORMS = [
  { form: 'field_report', label: 'Field Report' },
  { form: 'parts_list', label: 'Parts List' },
  { form: 'lube', label: 'Field Lube Report' },
  { form: 'rental', label: 'Rental Check-Out / In' },
];

const linkCls = 'rounded-md border border-slate-300 px-2 py-1 text-xs font-semibold text-slate-700 hover:bg-slate-50';

export function PrintForms({ woId, me }: { woId: number; me: Me }) {
  const url = (form: string, q = '') => `/api/work-orders/${woId}/pdf/${form}${q}`;
  const office = me.role !== 'MECHANIC';
  return (
    <Card title="Print forms">
      <ul className="space-y-2 text-sm">
        {FORMS.map((f) => (
          <li key={f.form} className="flex flex-wrap items-center gap-2">
            <span className="mr-auto font-medium">{f.label}</span>
            <a className={linkCls} href={url(f.form)} target="_blank" rel="noreferrer">Print</a>
            <a className={linkCls} href={url(f.form, '?download=1')}>Download</a>
            {f.form === 'parts_list' && office && (
              <a className={linkCls} href={url(f.form, '?prices=0')} target="_blank" rel="noreferrer" title="Customer copy without cost, list, sell or extended">
                No prices
              </a>
            )}
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-slate-500">Opens the PDF in a new tab; use the browser&apos;s Print button.</p>
    </Card>
  );
}
